<template>
  <div>
    <el-divider>{{$t('私有属性')}}</el-divider>
    <el-form-item :label="$t('图片上传')">
        <l-upload listType="picture-card" v-model="data.folderId" @getFileList="getFileList" :limit="1"></l-upload>
    </el-form-item>
    <el-form-item :label="$t('最大高度')">
      <el-input-number v-model="data.maxHeight"
                    controls-position="right"
                    :placeholder="$t('请输入图片最大高度')"
                    :min="0"></el-input-number>
    </el-form-item>
    <!-- <el-form-item :label="$t('CSS配置')">
        <el-input v-model="data.css" :rows="6" type="textarea" :placeholder="$t('请输入cssJSON配置')"></el-input>
    </el-form-item> -->
  </div>
</template>

<script>
import {get} from 'lodash'
export default {
    name: "config-txt",
    props: ['data'],
    data () {
        return{}
    },
    methods: {
       getFileList (list) {
        let url = get(list, '0.url', '')
        console.log(url, 'url')
        this.data.url=url.substr(0, url.indexOf('?token'))
       }
    }
}
</script>

